import { render, staticRenderFns } from "./InvoicesDetailList.vue?vue&type=template&id=2df66fd0&"
import script from "./InvoicesDetailList.vue?vue&type=script&lang=js&"
export * from "./InvoicesDetailList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDetailList.vue?vue&type=style&index=0&id=2df66fd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports